var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.868408H0V23.1316H20V0.868408ZM8.53674 20.0533H2.85281V3.79926H8.54975L8.53674 20.0533ZM12.9417 3.8166C13.491 3.80691 14.0365 3.90897 14.5451 4.11658C15.0537 4.32419 15.5149 4.63302 15.9005 5.02431C16.2861 5.4156 16.5881 5.88118 16.7883 6.39279C16.9884 6.90439 17.0825 7.45134 17.0648 8.00043C17.0648 11.2348 14.264 11.9545 12.9287 11.9371H10.7089V3.82093L12.9417 3.8166ZM10.7089 20.0923V12.0412L18.5129 20.0923H10.7089Z",
    fill: "#0E6CB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNar);
export default __webpack_public_path__ + "static/media/nar.1e38d484b73f20715be69832cc187a19.svg";
export { ForwardRef as ReactComponent };